/**
 * GENERATED by tools/buildCredits.ts from docs/licenses.csv. Do not edit by hand.
 *
 * The CSV is the legal record; this is its public face. Regenerate after any change to
 * the ledger — `npm run credits`.
 */

export interface CreditEntry {
  name: string;
  category: string;
  author: string;
  license: string;
  url: string;
}

export const CREDITS: readonly CreditEntry[] = [
  {
    "name": "@babylonjs/core 9.18.0",
    "category": "dependency",
    "author": "Microsoft / Babylon.js team",
    "license": "Apache-2.0",
    "url": "https://github.com/BabylonJS/Babylon.js"
  },
  {
    "name": "vite 8.1.5",
    "category": "dependency",
    "author": "VoidZero / Evan You",
    "license": "MIT",
    "url": "https://github.com/vitejs/vite"
  },
  {
    "name": "vite-plugin-glsl 1.6.1",
    "category": "dependency",
    "author": "Ustym Ukhman",
    "license": "MIT",
    "url": "https://github.com/UstymUkhman/vite-plugin-glsl"
  },
  {
    "name": "vitest 4.1.10",
    "category": "dependency",
    "author": "VoidZero",
    "license": "MIT",
    "url": "https://github.com/vitest-dev/vitest"
  },
  {
    "name": "playwright 1.62.0",
    "category": "dependency",
    "author": "Microsoft",
    "license": "Apache-2.0",
    "url": "https://github.com/microsoft/playwright"
  },
  {
    "name": "typescript 6.0.3",
    "category": "dependency",
    "author": "Microsoft",
    "license": "Apache-2.0",
    "url": "https://github.com/microsoft/TypeScript"
  },
  {
    "name": "eslint 10.8.0",
    "category": "dependency",
    "author": "OpenJS Foundation",
    "license": "MIT",
    "url": "https://github.com/eslint/eslint"
  },
  {
    "name": "typescript-eslint 8.65.0",
    "category": "dependency",
    "author": "typescript-eslint",
    "license": "MIT",
    "url": "https://github.com/typescript-eslint/typescript-eslint"
  },
  {
    "name": "tsx 4.20.6",
    "category": "dependency",
    "author": "Hiroki Osame",
    "license": "MIT",
    "url": "https://github.com/privatenumber/tsx"
  },
  {
    "name": "sfc32 + cyrb128 PRNG",
    "category": "code",
    "author": "bryc",
    "license": "Public domain",
    "url": "https://github.com/bryc/code/blob/master/jshash/PRNGs.md"
  },
  {
    "name": "ACES filmic tonemap approximation",
    "category": "code",
    "author": "Krzysztof Narkowicz",
    "license": "Public domain (blog-published formula)",
    "url": "https://knarkowicz.wordpress.com/2016/01/06/aces-filmic-tone-mapping-curve/"
  },
  {
    "name": "Gerstner wave formulation",
    "category": "technique",
    "author": "NVIDIA GPU Gems 1 ch.1 (Finch)",
    "license": "Technique/algorithm - not copyrighted code",
    "url": "https://developer.nvidia.com/gpugems/gpugems/part-i-natural-effects/chapter-1-effective-water-simulation-physical-models"
  },
  {
    "name": "Metal 053 C (steel-rusted)",
    "category": "texture",
    "author": "ambientCG (Lennart Demes)",
    "license": "CC0 1.0 Universal",
    "url": "https://ambientcg.com/view?id=Metal053C"
  },
  {
    "name": "Metal 055 B (steel-painted)",
    "category": "texture",
    "author": "ambientCG (Lennart Demes)",
    "license": "CC0 1.0 Universal",
    "url": "https://ambientcg.com/view?id=Metal055B"
  },
  {
    "name": "Metal Plates 013 (steel-plate)",
    "category": "texture",
    "author": "ambientCG (Lennart Demes)",
    "license": "CC0 1.0 Universal",
    "url": "https://ambientcg.com/view?id=MetalPlates013"
  },
  {
    "name": "Metal Walkway 014 (walkway)",
    "category": "texture",
    "author": "ambientCG (Lennart Demes)",
    "license": "CC0 1.0 Universal",
    "url": "https://ambientcg.com/view?id=MetalWalkway014"
  },
  {
    "name": "Metal 046 B (steel-worn)",
    "category": "texture",
    "author": "ambientCG (Lennart Demes)",
    "license": "CC0 1.0 Universal",
    "url": "https://ambientcg.com/view?id=Metal046B"
  },
  {
    "name": "Concrete 034 (concrete)",
    "category": "texture",
    "author": "ambientCG (Lennart Demes)",
    "license": "CC0 1.0 Universal",
    "url": "https://ambientcg.com/view?id=Concrete034"
  },
  {
    "name": "Barlow Condensed (200/300/400/600/700 latin)",
    "category": "font",
    "author": "Jeremy Tribby",
    "license": "SIL Open Font License 1.1",
    "url": "https://fonts.google.com/specimen/Barlow+Condensed"
  },
  {
    "name": "IBM Plex Mono (400/500 latin)",
    "category": "font",
    "author": "Mike Abbink / Bold Monday for IBM",
    "license": "SIL Open Font License 1.1",
    "url": "https://fonts.google.com/specimen/IBM+Plex+Mono"
  },
  {
    "name": "Title screen intro film",
    "category": "video",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "30 mm autocannon report",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Rig horn",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Radar acquisition ping (friendly)",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Radar acquisition ping (hostile)",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Torpedo launch",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Torpedo run water",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Torpedo hit",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Depth charge lift",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Depth charge column",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Depth charge water entry",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Depth charge launch",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "30 mm water hit (take 1)",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "30 mm water hit (take 2)",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "30 mm hull hit",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Distant battle ambience",
    "category": "audio",
    "author": "Adam Peleg (project owner)",
    "license": "Owner-supplied — all rights retained by the project",
    "url": "supplied directly"
  },
  {
    "name": "Promo film score",
    "category": "music",
    "author": "Generated with ElevenLabs Music (prompted by the project)",
    "license": "Output owned by the project under ElevenLabs paid-plan terms — NOT public domain: ElevenLabs retains a perpetual sublicensable licence",
    "url": "https://elevenlabs.io/"
  }
];
